module.exports = __webpack_public_path__ + "img/micromall_retailStore1.97cb5097.png";